/**
 * ObsidianWeb — React app entry point.
 *
 * Mounts the Shell component into the `#root` div. This replaces the vanilla
 * JS first-vertical implementation in `index.html` with the full React app.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Shell } from './components/Shell.js';
import './styles/obsidian-vars.css';
import './styles/responsive.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <Shell />
  </StrictMode>,
);
